export type ConsentFormTemplate = {
  id: string
  home: string
  title: string
  body: string
  isArchived: boolean
  isMaster: boolean
  editedBy?: string
  editedOn?: string
  createdBy: string
  createdOn: string
  type?: ConsentType
  isCreated?: boolean
}

export type ConsentSendForm = {
  id?: string
  consentTemplate?: string
  title?: string
  isRefused?: boolean
}

export type CreateConsentFormsJSON = {
  resident: string
  nextReviewDate: string | null
  consents: ConsentSendForm[]
}

export type ConsentType = 'consent' | 'lackOfCapacity'

export enum ConsentStatus {
  noStatus = 'no-status',
  consentNotObtained = 'consent-not-obtained',
  completed = 'completed',
  planned = 'planned',
  requested = 'requested',
  scheduled = 'scheduled',
  postponed = 'postponed',
  cancelled = 'cancelled',
  withdrawn = 'withdrawn',
  refused = 'refused',
  provided = 'provided'
}
